var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentLedgerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10719_31630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7188 6.25512L12.3018 1.9727L5.88476 6.25512C5.78262 6.32381 5.69896 6.41659 5.64115 6.52526C5.58335 6.63393 5.55318 6.75516 5.55331 6.87826L5.55331 20.7199C5.55217 20.8186 5.57077 20.9165 5.60802 21.0079C5.64526 21.0993 5.70039 21.1823 5.77018 21.2521C5.83997 21.3219 5.923 21.377 6.0144 21.4143C6.10579 21.4515 6.20371 21.4701 6.3024 21.469H18.3011C18.3998 21.4701 18.4977 21.4515 18.5891 21.4143C18.6805 21.377 18.7635 21.3219 18.8333 21.2521C18.9031 21.1823 18.9583 21.0993 18.9955 21.0079C19.0327 20.9165 19.0513 20.8186 19.0502 20.7199L19.0502 6.87826C19.0503 6.75516 19.0202 6.63393 18.9624 6.52526C18.9046 6.41659 18.8209 6.32381 18.7188 6.25512V6.25512Z",
    stroke: "#293A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3003 6.52539C12.9216 6.52539 13.4253 6.02171 13.4253 5.40039C13.4253 4.77907 12.9216 4.27539 12.3003 4.27539C11.679 4.27539 11.1753 4.77907 11.1753 5.40039C11.1753 6.02171 11.679 6.52539 12.3003 6.52539Z",
    fill: "#293A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5251 10.5H9.52515H11.1615C11.7402 10.5 12.2951 10.7258 12.7043 11.1276C13.1135 11.5295 13.3433 12.0745 13.3433 12.6429C13.3433 13.2112 13.1135 13.7562 12.7043 14.1581C12.2951 14.5599 11.7402 14.7857 11.1615 14.7857H9.52515L12.7979 18",
    stroke: "#179778",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52515 12.75H15.5251",
    stroke: "#179778",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10719_31630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLedgerIcon);
export default __webpack_public_path__ + "static/media/paymentLedgerIcon.d4a60fa83fba58f889c49740d886ddb6.svg";
export { ForwardRef as ReactComponent };